import { ContainerComponent, wrap } from 'AppReact';
import { Tab } from './molecules';
import { FlexCenterWrapper } from 'wrappers';
import Controller from './controller'
import internalState from './internalState';

export const definition = {
  name: 'TabsFilter',
  controller: Controller,
  initialProps: ({ selectedTabId, tabs }) => ({ selectedTabId, tabs }),
  props: internalState,
  elements: [
    {
      component: Tab,
      name: 'Tab',
      isListOf: 'tabs',
      bindings: ({ tab, selectedTabId }) => ({ selectedTabId, tab, selected: tab.id === selectedTabId }),
    },
  ]
}

const TabsFilter = wrap(ContainerComponent(definition), FlexCenterWrapper);
export default TabsFilter;